import { createContext } from "react";

export type Claims = {
  claims?: Record<string, number>;
  domainId?: string;
  countryId?: string;
  flags?: number;
  pharmacyId?: string;
  pin?: boolean;
};

export interface ClaimsContextValue {
  claims: Claims | undefined;
  isLoading: boolean;
}

export const ClaimsContextDefaultValue: ClaimsContextValue = {
  claims: undefined,
  isLoading: false,
};

export const ClaimsContext = createContext<ClaimsContextValue>(ClaimsContextDefaultValue);
